import React, { useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import i18n from 'I18n';

import { InsertParamDropdown } from 'components/base/ActionsDropdown';
import CustomTitleLabelWithEditorBar from 'components/base/CustomTitleLabelWithEditorBar';
import CustomTitleWithInput from 'components/base/CustomTitleWithInput';
import {
  ReactHookFormErrorMessage,
  hasError,
} from 'components/base/ErrorFieldMessage';
import ImageUploader from 'components/base/ImageUploader';
import CustomRadioWithTitleAndRelated from 'components/customer/CustomRadioWithTitleAndRelated';
import WechatContentInlineEditor from 'components/message/WechatContentInlineEditor';
import WechatTemplateSelectDropdown from 'components/message/WechatTemplateSelectDropdown';
import {
  AppCampaignDetailUrl,
  CampaignDetailUrl,
  LanguageConfig,
  MessageWhatsappTemplateType,
} from 'config/CustomEnums';

import './MessageGeneralSectionWechat.scss';

function MessageGeneralSectionWechatReuseSection({
  language,
  isRecurringMessage = false,
}) {
  const { watch, setValue, clearErrors, formState } = useFormContext();
  const { errors } = formState;

  const additionalFieldName = isRecurringMessage ? 'recurringMessage.' : '';
  const templateField = `${additionalFieldName}translations.${language}.wechatTemplate`;
  const wechatBodyField = `${additionalFieldName}translations.${language}.wechatBody`;
  const wechatRedirectPageField = `${additionalFieldName}translations.${language}.wechatRedirectPage`;

  const template = watch(templateField);
  const wechatRedirectPage = watch(wechatRedirectPageField);

  return (
    <div className={'message-general-section-wechat'}>
      <label className="create-section-title">
        {i18n.t('general', { locale: language })}
      </label>

      <WechatTemplateSelectDropdown
        title={'Template'}
        description={
          'Please select the respective language of the Wechat template'
        }
        customClass={hasError(errors, templateField) ? 'field-has-error' : ''}
        isPrompt
        defaultValue={
          template
            ? {
                value: template,
                label: template?.name,
              }
            : null
        }
        setValue={(value) => {
          setValue(templateField, value, { shouldDirty: true });
          setValue(wechatBodyField, null, {
            shouldDirty: true,
          });
          clearErrors();
        }}
      />
      <ReactHookFormErrorMessage errors={errors} id={templateField} />

      {template?.name && (
        <>
          <div className="d-flex flex-column">
            <div className="create-section-label create-section-label-bottom-space">
              {'Content'}
            </div>
            <WechatContentInlineEditor
              key={'body'}
              customStyle={'body'}
              language={language}
              baseFieldName={wechatBodyField}
              contentText={template?.content?.trimEnd()}
            />
          </div>
        </>
      )}
      <div className="d-flex flex-column">
        <div className="create-section-label create-section-label-bottom-space">
          {'Redirect Page (optional)'}
        </div>
        <InsertParamDropdown
          name={wechatRedirectPageField}
          value={wechatRedirectPage}
          language={language}
          dropdownClass={
            hasError(errors, wechatRedirectPageField) ? 'field-has-error' : ''
          }
          setValue={(value) => {
            setValue(wechatRedirectPageField, value, { shouldDirty: true });
          }}
          isWechat={true}
        />
      </div>
    </div>
  );
}

export default MessageGeneralSectionWechatReuseSection;
